import React, { useEffect } from "react";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { HeppaiRoute } from "./Route";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "context/AuthContext";
import { UserProvider } from "context/UserContext";
import { TourProvider } from "@reactour/tour";
import { CreateCampaignSteps } from "@components/GuidedTour/steps/CreateCampaignSteps";

import { startOtelInstrumentation } from "./opentelemetry";

if (process.env.REACT_APP_INSTRUMENTED === "TRUE") {
  startOtelInstrumentation();
}

const App: React.FC = () => {
  return (
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}
    >
      <TourProvider showBadge={false} steps={CreateCampaignSteps} scrollSmooth>
        <AuthProvider>
          <UserProvider>
            <Router>
              <HeppaiRoute />
            </Router>
          </UserProvider>
        </AuthProvider>
      </TourProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
